export default {
  state: {
    patterns: [],
    loading: false,
  },
  getters: {
    patterns: state => state.patterns,
    loading: state => state.loading,
  },
  mutations: {
    setPatterns(state, patterns) {
      state.patterns = patterns;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const patterns = await axios.get('api/todo-recurring-patterns');
        commit('setPatterns', patterns);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/todo-recurring-patterns/${id}`);
    },
    async create({ commit }, pattern) {
      await axios.post('api/todo-recurring-patterns', pattern);
    },
    async update({ commit }, pattern) {
      await axios.put('api/todo-recurring-patterns', pattern);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/todo-recurring-patterns/${id}`);
    },
  },
};
